import { Flex, Stack, TextInput } from "@mantine/core";
import { CloseOutlined, SearchOutlined } from "@mui/icons-material";
import { SvgIcon } from "@mui/material";
import { FC } from "react";
import { ReferralFilterButton, ReferralFilterPills } from "./ReferralFilters";
import { ReferralFilterState } from "./useReferralFilters";

type ReferralHeaderProps = {
    search: string;
    setSearch: (search: string) => void;
    filters: ReferralFilterState;
    setFilters: (filters: ReferralFilterState) => void;
};

export const ReferralHeader: FC<ReferralHeaderProps> = ({
    search,
    setSearch,
    filters,
    setFilters
}) => {
    return (
        <Stack gap="xs">
            <Flex justify="space-between" align="center">
                <Flex flex={1} gap="sm" align="center">
                    <TextInput
                        data-testid="search.bar.input"
                        placeholder="Search referrals..."
                        leftSection={<SvgIcon component={SearchOutlined} />}
                        value={search}
                        onChange={(e) => setSearch(e.currentTarget.value)}
                        rightSection={
                            search ? (
                                <SvgIcon
                                    component={CloseOutlined}
                                    sx={{
                                        width: "0.9rem",
                                        height: "0.9rem",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => setSearch("")}
                                />
                            ) : null
                        }
                    />
                    <ReferralFilterButton
                        filters={filters}
                        setFilters={setFilters}
                    />
                </Flex>
                <Flex flex={1} justify="flex-end" />
            </Flex>
            <ReferralFilterPills
                filters={filters}
                setFilters={setFilters}
            />
        </Stack>
    );
};
